/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
const Dep = Object.getPrototypeOf(Vue.observable({}).__ob__.dep).constructor;

/**
 * 执行一个函数，返回函数的结果。特殊的是，在这个里面会暂停 Vue 的依赖收集
 *
 * 对于那种复杂的 computed getter，使用这个也许可以提高性能吧
 *
 * @template T
 * @param {() => T} callback
 * @return {T}
 */
export function vueBailDepCollector(callback) {
  // 模拟 pushTarget 和 popTarget
  const lastTarget = Dep.target;
  Dep.target = undefined;
  try {
    return callback();
  } finally {
    Dep.target = lastTarget;
  }
}